import axios from 'axios';
import notify from "devextreme/ui/notify";


export default class Taxios {
    config = {};

    constructor(url,method,data,contentType) {
        let apiPort = "";
        if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
            apiPort = ":8765";//":3030";;//
        }

        if (url.includes("http://") || url.includes("https://") ) {
            this.config['url'] = url;
        } else {
            this.config['url'] =  window.location.protocol +"//" +  window.location.hostname + apiPort  +url;
            //"https://"+ window.location.hostname + apiPort  +url;
        }

        if (method) {
            this.config['method'] = method;
        } else {
            this.config['method'] = 'get';
        }

        if(data && contentType != null && contentType == "multipart/form-data"){
            this.config['data'] = data;
        }else if (data) {
            this.config['data'] = JSON.stringify(data);
        }

        this.setHeaderToken();
    }


    setHeaderToken() {
        this.config['headers'] = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('token') !== undefined && localStorage.getItem('token') !== null ? 'Bearer ' + localStorage.getItem('token') : "",
            'Access-Control-Allow-Origin': 'http://localhost:3000'
        };
    }

    run() {
        const result = axios(this.config)
            .then((response) => {
                return response;
            }).catch((error) => {
               //debugger;
                if (error && error.response && error.response.status === 401) {
                    localStorage.removeItem('loggedIn');
                    localStorage.removeItem('token');
                    localStorage.removeItem('username');
                    localStorage.removeItem('name');
                    window.location.href = "/";
                }
                notify("text", "error", 600);
                console.log(error);
                return error;
            });

        return result;

    }

}

